import { useQuery } from "react-query"
import { AxiosResponse } from "axios"
import reportService from "api/reportService"

const useGetReportStatuses = (enabled: boolean) => {
  return useQuery(
    "report-statuses",
    async () => {
      const res: AxiosResponse<any> = await reportService.getReportStatuses()

      return res.data
    },
    { enabled },
  )
}

export default useGetReportStatuses
